import { Splide } from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';
import '@splidejs/splide/css';

const sliders = {
  width: window.innerWidth as number,
  init() {
    this.heroSlider();
    this.trophiesSlider();
    this.prodSlider();
    this.uspSlider();
    this.catSlider();
    this.testimonials();
    this.blogs();
    this.subCats();
    this.setProdThumbnailsSlider();
    this.resetSlider();
  },

  resetSlider() {
    window.addEventListener('reset', () => {
      this.setProdThumbnailsSlider();
    });
  },

  removeSlider(item: HTMLElement) {
    const items = item.querySelectorAll(
      '.splide__slide',
    ) as NodeListOf<HTMLElement>;
    item.classList.remove('splide');
    item.classList.remove('jsCatSlider');
    item.classList.remove('jsProdSlider');
    item.firstElementChild?.classList.remove('splide__track');
    const list = item.firstElementChild?.firstElementChild;
    list?.classList.remove('splide__list');
    list?.classList.add('splide__grid');

    if (items) {
      Array.from(items).forEach((el) => {
        const item = el as HTMLElement;
        item.classList.remove('splide__slide');
      });
    }
  },

  uspSlider() {
    const sliders = document.querySelectorAll(
      '.jsUspSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        pagination: false,
        arrows: false,
        autoplay: true,
        speed: 800,
        perPage: 3,
        destroy: true,
        breakpoints: {
          1200: {
            perPage: 1,
            destroy: false,
          },
        },
      }).mount();
    });
  },

  trophiesSlider() {
    const sliders = document.querySelectorAll(
      '.jsTrophiesList',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        pagination: false,
        arrows: true,
        autoplay: true,
        speed: 800,
        perPage: 6,
        gap: 15,

        breakpoints: {
          1200: {
            pagination: true,
            perPage: 3,
            gap: 20,
          },

          768: {
            pagination: true,
            gap: 15,
            perPage: 2,
            padding: { right: '30%' },
          },
        },
      }).mount();
    });
  },

  catSlider() {
    const sliders = document.querySelectorAll(
      '.jsCatSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        pagination: false,
        arrows: true,
        autoplay: true,
        speed: 800,
        perPage: 6,
        gap: 15,
        destroy: true,
        breakpoints: {
          1200: {
            destroy: false,
            perPage: 1,
            grid: {
              rows: 2,
              cols: 3,
              gap: {
                row: '50px',
                col: '25px',
              },
            },
          },

          768: {
            perPage: 1,
            grid: {
              rows: 2,
              cols: 2,
              gap: {
                row: '30px',
                col: '15px',
              },
            },
          },

          500: {
            perPage: 1,
            grid: {
              rows: 2,
              cols: 2,
              gap: {
                row: '20px',
                col: '15px',
              },
            },
          },
        },
      }).mount({ Grid });
    });
  },

  heroSlider() {
    const heroSliders = document.querySelectorAll(
      '.jsHeroSlider',
    ) as NodeListOf<HTMLElement>;
    heroSliders.forEach((el) => {
      const slider = new Splide(el, {
        type: 'loop',
        perPage: 1,
        pagination: true,
        arrows: false,
        autoplay: true,
        speed: 800,
      });

      slider.on('pagination:mounted', function (data) {
        data.list.classList.add('splide__pagination--custom');
        data.items.forEach(function (item) {
          item.button.innerHTML = `<span>0${item.page + 1}</span>`;
        });
      });
      slider.mount();
    });
  },

  prodSlider() {
    const sliders = document.querySelectorAll(
      '.jsProdSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'carousel',
        pagination: false,
        arrows: true,
        autoplay: true,
        speed: 800,
        gap: 18,
        perPage: 5,
        breakpoints: {
          1200: {
            perPage: 3,
          },

          768: {
            perPage: 2,
          },
          480: {
            perPage: 1,
            padding: { right: '30%' },
          },
        },
      }).mount();
    });
  },

  testimonials() {
    const sliders = document.querySelectorAll(
      '.jsTestimonialsSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        pagination: false,
        arrows: true,
        autoplay: true,
        speed: 800,
        perPage: 1,
      }).mount();
    });
  },

  blogs() {
    const sliders = document.querySelectorAll(
      '.jsBlogs',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        pagination: false,
        arrows: true,
        autoplay: true,
        speed: 800,
        perPage: 3,
        breakpoints: {
          1200: {
            perPage: 1,
          },
        },
      }).mount();
    });
  },

  subCats() {
    const sliders = document.querySelectorAll(
      '.jsSubCats',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        pagination: false,
        arrows: true,
        autoplay: true,
        speed: 800,
        perPage: 6,
        gap: 10,

        breakpoints: {
          1200: {
            gap: 10,
            perPage: 4,
          },

          768: {
            perPage: 1,
          },
        },
      }).mount();
    });
  },

  setProdThumbnailsSlider() {
    const slider = document.getElementById('mainImage') as
      | HTMLElement
      | undefined;
    if (slider) {
      if (this.width < 768) {
        const main = new Splide(slider, {
          type: 'loop',
          pagination: false,
          arrows: true,
          gap: '20px',
          perPage: 1,
          perMove: 1,
        });
        main.mount();
      } else {
        this.removeSlider(slider);
      }
    }
  },
};

export default sliders;
